export const validateInput = (input: string): string => {
  const sanitizedInput = input?.replace(/['",,*^/\\[\]+=:.()]/g, '').replace(/(https?:\/\/|www\.)/gi, '')
  return sanitizedInput
}

export const testIfInputIsPositiveNumber = (input: string): boolean => {
  return /^[0-9]*$/.test(input)
}
